'use client'

import { BugIcon } from 'lucide-react'
import { useEffect } from 'react'
import { Button } from '~/components/ui/button'

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error(props: ErrorProps) {
  useEffect(() => {
    console.error(props.error)
  }, [props.error])

  return (
    <div className="m-2 flex items-center space-x-4 rounded-xl p-4 ring-2 ring-red-400">
      <BugIcon className="size-14 text-red-400" />
      <div className="space-y-1">
        <h5 className="text-lg font-medium text-red-400">Что-то пошло не так!</h5>
        <p>
          <Button className="w-fit" onClick={() => props.reset()} variant="secondary">
            Повторить
          </Button>
        </p>
      </div>
    </div>
  )
}
